import React from 'react';

import './pevalue-graph.styl'

function PEValueGraph({ currentSelectedDamageLayer }) {
  let fillHeight;

  fillHeight = (currentSelectedDamageLayer.areaPEValue / 12) * 100
  if (fillHeight > 100) {
    fillHeight = 100;
  }
  
  return (
    <div className="pevalue-graph">
      <div className="pevalue-graph__chart-wrapper">
        <div className="label-container">
          Pe = 
          {' '}
          {currentSelectedDamageLayer?.areaPEValue?.toFixed(2)}
          mm
        </div>
        <div className="vertical-gauge">
          <div className="gauge-container">
            <div
              className={`gauge-fill ${fillHeight === 100 ? 'gauge-fill--exceeded' : ''}`}
              style={{ height: `${fillHeight}%` }}
            />
       
            <div className="marker-container">
            
              <div className="marker marker-5mm">
                <div className="marker-line" />
                <span className="marker-label">2.5mm</span>
              </div>
          
              <div className="marker marker-10mm">
                <div className="marker-line" />
                <span className="marker-label">5mm</span>
              </div>
          
              <div className="marker marker-15mm">
                <div className="marker-line" />
                <span className="marker-label">7.5mm</span>
              </div>
          
              <div className="marker marker-20mm">
                <div className="marker-line" />
                <span className="marker-label">10mm</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PEValueGraph